import client from '../client';
export default {
  // 分页查询 Campaign 列表
  getCpcCampaigns: data => {
    return client.get('seller/cpc/campaigns', { params: data }).then(res => res.data);
  },
  getCpcCampaignsById: data => {
    return client.get(`seller/cpc/campaigns/${data.campaignId}`).then(res => res.data);
  },
  // 特定 Campaign 指标 - 分页查询推广商品
  getCpcCampaignsProducts: data => {
    return client.get(`seller/cpc/campaigns/${data.campaignId}/products`).then(res => res.data);
  },
  // 特定 Campaign 指标 - 某 ASIN 下各 Publisher 列表
  getCpcCampaignsProductsPublishers: data => {
    return client.get(`seller/cpc/campaigns/${data.campaignId}/products/${data.productId}/publishers`).then(res => res.data);
  },
  // 特定 Campaign 指标 - 分页查询已参加 Publisher 列表
  getCpcCampaignsPublishers: data => {
    return client.get(`seller/cpc/campaigns/${data.campaignId}/publishers`).then(res => res.data);
  },
  // 特定 Campaign 指标 - 某 Publisher 下推广的 ASIN 列表
  getCpcCampaignsPublishersProducts: data => {
    return client.get(`seller/cpc/campaigns/${data.campaignId}/publishers/${data.publisherId}/products`).then(res => res.data);
  },
  // 创建/编辑 Campaign 时，预览 ASIN 列表对应的商品列表
  getCpcCampaignsAsinPreview: data => {
    return client.get(`seller/cpc/campaigns/asin-preview`, { params: data }).then(res => res.data);
  },
  //创建/编辑 Campaign 时，分页查询可选的 Publisher 列表
  getCpcCampaignsPublisherPreview: data => {
    return client.get(`seller/cpc/campaigns/eligible-publishers`, { params: data }).then(res => res.data);
  },
  // 创建提交 Campaign
  createCpcCampaign: data => {
    return client.post(`seller/cpc/campaigns`, data).then(res => res.data);
  },
  //编辑 Campaign 第一步 - 基本信息
  setCpcCampaignsEditStep1: data => {
    return client.post(`seller/cpc/campaigns/${data.campaignId}/edit/step1`, data).then(res => res.data);
  },
  //编辑 Campaign 第二步 - 商品列表
  setCpcCampaignsEditStep2: data => {
    return client.post(`seller/cpc/campaigns/${data.campaignId}/edit/step2`, data).then(res => res.data);
  },
  //编辑 Campaign 第三步 - Publisher 列表
  setCpcCampaignsEditStep3: data => {
    return client.post(`seller/cpc/campaigns/${data.campaignId}/edit/step3`, data).then(res => res.data);
  },
  searchProducts: data => {
    return client.get(`seller/product/search`, { params: data }).then(res => res.data);
  },
}